import React, { useEffect, useState } from 'react';
import { useViewerStateStore, ViewerLoadingStateEnum } from '../../store/viewerStateStore';
import { useProductModelStore } from '../../store/productModelStore';

const LoadingStateComponent: React.FC = () => {

    const { loadingState } = useViewerStateStore();
    const { rootProductLoadingStates } = useProductModelStore();
    const [prevLoadingState, setPrevLoadingState] = useState<ViewerLoadingStateEnum>(ViewerLoadingStateEnum.Initial);

    useEffect(() => {
        if (loadingState !== prevLoadingState) {
            // If the loading state changes, we can perform actions based on the new state
            console.log(`Loading state: ${prevLoadingState} -> ${loadingState}`);
            setPrevLoadingState(loadingState);
        }
        
    }, [loadingState]); 
    
    useEffect(() => {
        if (Object.keys(rootProductLoadingStates).length > 0 && Object.values(rootProductLoadingStates).every(state => state === true)) {
            // All root products are loaded, we can set the loading state to ProductsRendered
            useViewerStateStore.getState().setLoadingState(ViewerLoadingStateEnum.ProductsRendered);
        }

        console.log("Root product loading states:", rootProductLoadingStates);

    }, [rootProductLoadingStates]);

    return (<>
        
    </>);
};

export default LoadingStateComponent;